import { V2L2SmallModalRoot } from '../V2L2ModalRoot'
import { V2L2ModalTitlebar, V2L1ModalDismissButton } from '../V2ModalTitlebar'
import { V2L1ModalDetailLabel, V2L2ModalContent, V2L2ModalDetailRoot } from '../V2ModalContent'
import { V2L2ModalActionbar } from '../V2L2ModalActionbar'
import { V2L1ReasonableButton } from '../../Button/V2L1ReasonableButton'
import { faNote } from '@fortawesome/pro-regular-svg-icons'
import { useCallback } from 'react'
import { V2L2StarRating } from '../../StarRating/V2L2StarRating'
import L1TextArea from '../../../form/l1/L1TextArea'
import L1VSpace from '../../../form/l1/L1VSpace'

interface V2L3FeedbackModalProps {
	loading: boolean
	onSubmit?: () => void,
	onDismissClick?: React.MouseEventHandler<HTMLButtonElement>
	overallExperience?: number
	easeOfNavigation?: number
	productQuality?: number
	whatWorked?: string
	generalFeedback?: string
	handleChangeOverallExperience: (value: number) => void
	handleChangeEaseOfNavigation: (value: number) => void
	handleChangeProductQuality: (value: number) => void
	handleChangeWhatWorked: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
	handleChangeGeneralFeedback: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
}

export const V2L3FeedbackModal = ({
	loading, 
	onSubmit, 
	onDismissClick, 
	overallExperience = 0, 
	easeOfNavigation = 0, 
	productQuality = 0, 
	whatWorked = '', 
	generalFeedback = '',
	handleChangeOverallExperience,
	handleChangeEaseOfNavigation,
	handleChangeProductQuality,
	handleChangeWhatWorked,
	handleChangeGeneralFeedback,
}: V2L3FeedbackModalProps) => {
	const handleSubmitFeedback = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
		e.preventDefault()
		onSubmit?.()
	}, [onSubmit])

	return (
		<V2L2SmallModalRoot>
			<V2L2ModalTitlebar
				title="Feedback"
				buttons={<V2L1ModalDismissButton onClick={onDismissClick} />}
			/>
			<V2L2ModalContent>
				<V2L2ModalDetailRoot>
					<V2L1ModalDetailLabel>How would you rate your overall experience with the app?</V2L1ModalDetailLabel>
					<V2L2StarRating value={overallExperience} onChange={handleChangeOverallExperience} disabled={loading} />
					<V2L1ModalDetailLabel>How easy was it to navigate the app?</V2L1ModalDetailLabel>
					<V2L2StarRating value={easeOfNavigation} onChange={handleChangeEaseOfNavigation} disabled={loading} />
					<V2L1ModalDetailLabel>How would you rate the quality of our product?</V2L1ModalDetailLabel>
					<V2L2StarRating value={productQuality} onChange={handleChangeProductQuality} disabled={loading} />
					<V2L1ModalDetailLabel>What features worked well or need additional development work?</V2L1ModalDetailLabel>
					<L1TextArea
						value={whatWorked}
						onChange={handleChangeWhatWorked}
						disabled={loading}
						rows={2}
					/>
					<L1VSpace spacing={1} />
					<V2L1ModalDetailLabel>What general feedback would you like to send?</V2L1ModalDetailLabel>
					<L1TextArea
						value={generalFeedback}
						onChange={handleChangeGeneralFeedback}
						disabled={loading}
						rows={2}
					/>
				</V2L2ModalDetailRoot>
			</V2L2ModalContent>
			<V2L2ModalActionbar>
				<V2L1ReasonableButton
					icon={faNote}
					label="Submit"
					onClick={handleSubmitFeedback}
					loading={loading}
				/>
			</V2L2ModalActionbar>
		</V2L2SmallModalRoot>
	)
}
